import { action } from 'satcheljs';

export interface NewConsumerRecruitmentProps {
    firstName: string;
    userEmail: string;
    ageResponse: string;
    purposeResponse: string;
}

export const logNewConsumerRecruitmentResponse = action(
    'logNewConsumerRecruitmentResponse',
    (newConsumerRecruitmentProps: NewConsumerRecruitmentProps) => newConsumerRecruitmentProps
);
